import { Component, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdditionalServicesFeeModel, OngoingComplianceModel } from 'src/Models/OngoingComplianceModel';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { PricingQuotesService } from 'src/Services/pricing-quotes.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { checkStepIsCompleted, getIncompletedStep } from 'src/app/Shared/commonMethods';
import { Globle } from 'src/app/Shared/global';
import { UpdatedBaseRateModel } from 'src/Models/UpdatedBaseRateModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-pricing-quotes-proposal',
  templateUrl: './pricing-quotes-proposal.component.html',
  styleUrls: ['./pricing-quotes-proposal.component.css']
})
export class PricingQuotesProposalComponent implements OnInit {
  SelectedTool: string;
  userID: any;
  clientInformationId: number = 0;
  priceQuoteId: number = 0;
  tokenKey: string;
  isloading: boolean = false;

  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  stateCode: any;
  isRecord: boolean = false;
  quoteName: string;
  listofCompliance: OngoingComplianceModel[];
  listofMiscellaneous: OngoingComplianceModel[];
  listofAdditionalServices: AdditionalServicesFeeModel[];
  listofUpdatedAddOnServices: UpdatedBaseRateModel[];
  listofUpdatedAddOnOtherRegulatory: UpdatedBaseRateModel[];
  listofConsultingProjects: UpdatedBaseRateModel[];
  complianceTotal: number = 0;
  yearlycomplianceTotal: number = 0;
  baseUrl: string;
  isConsultingProjects: boolean = false;
  consultingTotal: number = 0;

  isProposalDetailsCompleted: boolean;
  currentActiveTab: number = 1;

  url: string;
  tabId: number = 0;

  mainUrl: string;
  subUrl: string;

  companyName: string;

  advisoryQuotebtndisplay: boolean = false;
  solutionQuotebtndisplay: boolean = false;

  isMarketEntry:boolean=false;
  isMisc:boolean=false;
  isAddOn:boolean=false;
  isRegulatory:boolean=false;
  isAdditionalServices:boolean=false;

  isCompliance:boolean=false;
  solutionTotal:number=0;
  regulatoryTotal:number=0;
  miscTotal:number=0;
  additionalServicesTotal:number=0;

  dropdownListReviewStatus: any = [];
  selectedItemsReviewStatus: any = [];
  dropdownSettingsReviewStatus: any = {};

  quoteReviewStatusId: number = 0;
  quoteReviewnotes: string = '';

  ReviewStatus: number = 0;
  ReviewNotes: string = '';
  IsSendReview: boolean = false;
  SendForReviewDate: string = '';

   isSubmit: boolean = false;
   
  constructor(private readonly router: Router,
    private readonly PricingQuotesMaster: PricingQuotesService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly activedRoute: ActivatedRoute,
    private readonly toastr: ToastrService,
    private readonly htmlToPdf: HtmlToPdf,
    @Inject('BASE_URL') baseUrl: string,
    private readonly globle: Globle,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.userID = this.sessionStorageService.getAdminUserId();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.baseUrl = baseUrl;
    this.companyName = sessionStorage.getItem('ClientCompanyName');
    this.titleService.setTitle('Price Quote - ' + this.companyName);


    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {
          this.priceQuoteId = params['id'];
          this.GetComplianceByClientInformationId(this.priceQuoteId);
          this.GetAdvisorysolutionbuttonDataById(this.priceQuoteId);
          this.GetPriceQuoteReviewStatus(this.priceQuoteId);
        }
      }
    });

    this.mainUrl = '/admin/PricingQuote/';
    if (this.priceQuoteId != null) {
      this.GetProgressStepDetailsById(this.priceQuoteId);
      this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
    }
    else {
      this.globle.cApp.statusModel.isRateDetailsCompleted = null
      this.globle.cApp.statusModel.isQuoteDetailsCompleted = null
      this.globle.cApp.statusModel.isAddOnServicesCompleted = null
      this.globle.cApp.statusModel.isComplianceDetailsCompleted = null
      this.globle.cApp.statusModel.isProposalDetailsCompleted = null
      this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
    }
  }

  ngOnInit() {
    this.isloading = true;

    this.dropdownSettingsReviewStatus = {
      singleSelection: true,
      text: "Please Select Review Status",
      enableSearchFilter: false,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No Quote Review Status available',
      showCheckbox: false,
      enableFilterSelectAll: false
    };

    this.dropdownListReviewStatus = [];
    this.dropdownListReviewStatus.push({ "id": 1, "itemName": "In Review" })
    this.dropdownListReviewStatus.push({ "id": 2, "itemName": "Approved" })
    this.dropdownListReviewStatus.push({ "id": 3, "itemName": "Rejected" })
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  previousStep() {
    this.router.navigate(['/admin/' + this.SelectedTool + '/compliance/' + this.priceQuoteId]);
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  GetComplianceByClientInformationId(priceQuoteId) {
    this.blockDocument();
    this.PricingQuotesMaster.GetProposelByClientInformationId(this.tokenKey, priceQuoteId).subscribe(
      data => {
        if (data['status'] = 'Success') {
          this.unblockDocument();
          this.isloading = false;
          if (data['compliance'] != null && data['compliance'].length > 0) {
            this.listofCompliance = data['compliance'].filter(x => x.totalMonthlyCost != 0);
            if (this.listofCompliance.length > 0)
              this.isCompliance = true
          }

          if (data['marketEntryData'] != null && data['marketEntryData'].length > 0) {
            this.isMarketEntry = true;
          }
          else {
            this.isMarketEntry = false;
          }

          if (data['miscelleneous'] != null && data['miscelleneous'].length > 0) {
            this.listofMiscellaneous = data['miscelleneous'];
            for (let iCounter = 0; iCounter < this.listofMiscellaneous.length; iCounter++) {
              this.miscTotal = this.miscTotal + this.listofMiscellaneous[iCounter].totalMonthlyCost;
            }
            this.isMisc = true;
          }

          if (data['additionalServicesFees'] != null && data['additionalServicesFees'].length > 0) {
            this.listofAdditionalServices = data['additionalServicesFees'];
            for (let iCounter = 0; iCounter < this.listofAdditionalServices.length; iCounter++) {
              this.additionalServicesTotal = this.additionalServicesTotal + this.listofAdditionalServices[iCounter].additionalServicesAmount;
            }
            this.isAdditionalServices = true;
          }

          if (data['platFormOffering'] != null && data['platFormOffering'].length > 0) {
            this.listofUpdatedAddOnServices = data['platFormOffering'];
            for (let iCounter = 0; iCounter < this.listofUpdatedAddOnServices.length; iCounter++) {
              this.solutionTotal = this.solutionTotal + this.listofUpdatedAddOnServices[iCounter].totalAmount;
            }
            this.isAddOn = true;
          }

          if (data['regulatoryRequirement'] != null && data['regulatoryRequirement'].length > 0) {
            this.listofUpdatedAddOnOtherRegulatory = data['regulatoryRequirement'];
            for (let iCounter = 0; iCounter < this.listofUpdatedAddOnOtherRegulatory.length; iCounter++) {
              this.regulatoryTotal = this.regulatoryTotal + this.listofUpdatedAddOnOtherRegulatory[iCounter].monthlyRate;
            }
            this.isRegulatory = true;
          }

          if (data['updatedConsultingProjects'] != null && data['updatedConsultingProjects'].length > 0) {
            this.listofConsultingProjects = data['updatedConsultingProjects'];
            for (let iCounter = 0; iCounter < this.listofConsultingProjects.length; iCounter++) {
              this.consultingTotal = this.consultingTotal + this.listofConsultingProjects[iCounter].monthlyRate;
            }
            this.isConsultingProjects = true;
          }

          if (this.listofCompliance != null) {
            if (this.listofCompliance.length == 0) {
              this.isRecord = true;
            }
            else {
              if (this.listofCompliance[0].quoteName != null && this.listofCompliance[0].quoteName != "") {
                this.quoteName = " - " + this.listofCompliance[0].quoteName;
              }
              else {
                this.quoteName = "";
              }
              for (let iCounter = 0; iCounter < this.listofCompliance.length; iCounter++) {
                if (this.listofCompliance[iCounter].serviceName != 'Registered Agent Fees' && this.listofCompliance[iCounter].serviceName != 'Registered Agent Renewals') {
                  this.complianceTotal = this.complianceTotal + this.listofCompliance[iCounter].totalMonthlyCost;
                }

                if (this.listofCompliance[iCounter].serviceName == 'Registered Agent Fees' || this.listofCompliance[iCounter].serviceName == 'Registered Agent Renewals') {
                  this.yearlycomplianceTotal = this.yearlycomplianceTotal + this.listofCompliance[iCounter].totalMonthlyCost;
                }
              }
            }
          }
          else {
            this.isRecord = false;
          }
        }
        else {
          this.unblockDocument();
          this.isRecord = false;
        }
      }, error => {
        this.unblockDocument();
        this.stateCode = error
      }
    );
  }

  get hasRegisteredAgentFees(): boolean {
  if (!this.listofCompliance || this.listofCompliance.length === 0) {
    return false;
  }

  return this.listofCompliance.some(item =>
    item.totalMonthlyCost > 0 &&
    (item.serviceName === 'Registered Agent Fees' || item.serviceName === 'Registered Agent Renewals')
  );
}

  copy(el: HTMLDivElement) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(el.innerText).then(() => {
        this.toastr.success('Text copy successfully', 'Copied')
      }, (error) => {
      });
    }
  }

  activeTab(url: string, tabId: number) {

    if (this.priceQuoteId != null) {
      if (checkStepIsCompleted(url, this.globle.cApp.statusModel)) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + url + '/' + this.priceQuoteId;
        this.router.navigate([navigate]);
      }

      this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
      if (url == this.subUrl) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + this.subUrl + '/' + this.priceQuoteId;
        this.router.navigate([navigate]);
      }
    }
    else {
      if (checkStepIsCompleted(url, this.globle.cApp.statusModel)) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + url;
        this.router.navigate([navigate]);
      }

      this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
      if (url == this.subUrl) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + this.subUrl;
        this.router.navigate([navigate]);
      }
    }
  }

  GetProgressStepDetailsById(priceQuoteId: number) {
    this.PricingQuotesMaster.GetProgressStepDetailsById(this.tokenKey, priceQuoteId).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.globle.cApp.statusModel = result['progress'];
          this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
          this.activeTab('proposal', 9);
        }
      });
  }

  createMyPdf1() {
    this.blockDocument();
    
    this.PricingQuotesMaster.GenerateProposalV2(this.priceQuoteId, this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.downloadFile('PriceQuoteFinalProposal.pdf', data['url'], data['fileName']);
          this.unblockDocument();
        }
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  public downloadFile(filename: any, url: any, orignalFileName: any) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        sessionStorage.setItem('fileloading', 'false');
        this.htmlToPdf.DeletePDF(this.tokenKey, orignalFileName).subscribe(
          data => {
            this.unblockDocument();
          },
        );
      }
    );
  }

  Save() {
    let value = {
      priceQuoteId: this.priceQuoteId,
      IsProposalDetailsCompleted: true
    }
    this.blockDocument();
    this.PricingQuotesMaster.ProposalStepAddUpdateV2(this.tokenKey, value).subscribe(
      result => {
        this.unblockDocument();
        if (result['status'] == 'Success') {
          this.globle.cApp.statusModel.isProposalDetailsCompleted = true;
          this.showMessage('Price quote saved successfully', 'Success', 'success');
          this.router.navigate(['/admin/' + this.SelectedTool + '/pricing-quotes']);
        }
        else {
          this.showMessage(result['status'], 'Error', 'error');
        }
      },
      error => {
        this.unblockDocument();
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  GetAdvisorysolutionbuttonDataById(priceQuoteId: number) {
    this.PricingQuotesMaster.GetAdvisorysoultionbuttondisplay(priceQuoteId,this.tokenKey).subscribe(
      result => {
        if (result['status'] == 'Success') {
          if (result.lstdata[0].advisoryServices > 0) {
            this.advisoryQuotebtndisplay = true;
          }
          else {
            this.advisoryQuotebtndisplay = false;
          }

          if (result.lstdata[0].solutions > 0) {
            this.solutionQuotebtndisplay = true;
          }
          else {
            this.solutionQuotebtndisplay = false;
          }
        }

      });
  }

  createAdvisoryPdf() {
    this.blockDocument();

    this.PricingQuotesMaster.GenerateAdvisoryServicesQuote(this.priceQuoteId, this.companyName, this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.downloadFile('AdvisoryProposal.pdf', data['url'], data['fileName']);
          this.unblockDocument();
        }
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  createSolutionPdf() {
    this.blockDocument();

    this.PricingQuotesMaster.GenerateSolutionServicesQuote(this.priceQuoteId, this.companyName, this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.downloadFile('SolutionsProposal.pdf', data['url'], data['fileName']);
          this.unblockDocument();
        }
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  createMatrketEntryPdf() {
    this.blockDocument();
    this.PricingQuotesMaster.GenerateMarketEntryPDF(this.priceQuoteId, this.companyName, this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.downloadFile('MarketEntry.pdf', data['url'], data['fileName']);
          this.unblockDocument();
        }
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  GenerateMarketEntryReportPDF() {
    this.blockDocument();
    this.PricingQuotesMaster.GenerateMarketEntryReportPDF(this.priceQuoteId, this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.downloadFile('MarketEntryReport.pdf', data['url'], data['fileName']);
          this.unblockDocument();
        }
        else {
          this.unblockDocument();
        }
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  ExportToExcelQuote() {
    this.isloading = false;
    let tableData = document.getElementById("exportQuotetool").innerHTML;
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'PriceQuoteExport';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "PriceQuoteExport.xls");
  }


  GetPriceQuoteReviewStatus(priceQuoteId: number) {
    this.blockDocument();

    this.PricingQuotesMaster.GetPriceQuoteReviewStatus(this.tokenKey, priceQuoteId).subscribe(
      result => {
        this.unblockDocument();
        if (result['status'] == 'Success') {
          this.ReviewStatus = result['reviewInformation'].reviewStatus;
          this.ReviewNotes = result['reviewInformation'].reviewNotes;
          this.IsSendReview = result['reviewInformation'].isSendReview;
          this.SendForReviewDate = result['reviewInformation'].sendForReviewDate;
          this.companyName = result['reviewInformation'].companyName;

          sessionStorage.setItem('ClientCompanyName',this.companyName);

          this.titleService.setTitle('Price Quote - ' + this.companyName);
        }
        else {
          this.ReviewStatus = 0;
          this.ReviewNotes = '';
          this.IsSendReview = false;
          this.SendForReviewDate = '';
        }
      });
  }

  onCheckboxReviewStatus() {
    this.priceQuoteId = this.priceQuoteId;
    var PriceQuoteReviewStatus = this.dropdownListReviewStatus.filter(x => x.id == this.ReviewStatus)[0];
    this.selectedItemsReviewStatus = [];
    if (PriceQuoteReviewStatus != null) {
      this.quoteReviewStatusId = PriceQuoteReviewStatus.id;
      this.selectedItemsReviewStatus.push({ "id": PriceQuoteReviewStatus.id, "itemName": PriceQuoteReviewStatus.itemName })
    }

    this.quoteReviewnotes = "";

    document.getElementById("btnopenReviewStatuspopup").click();
    return;
  }

  onSelectReviewStatus($event: any) {
    this.quoteReviewStatusId = $event.id;
  }

  onDeSelectReviewStatus($event: any) {
    this.quoteReviewStatusId = 0;
  }

  onDeSelectAllReviewStatus($event: any) {
    this.quoteReviewStatusId = 0;
  }

  priceReviewStatus() {
    this.isSubmit = true;
    let isValid = true;

  // Review Status validation
  if (this.quoteReviewStatusId == 0) {
    isValid = false;
  }

  // Review Notes validation
  if (!this.quoteReviewnotes || this.quoteReviewnotes.trim() === '') {
    this.quoteReviewnotes = '';
    isValid = false;
  }

  // Stop if any validation fails
  if (!isValid) {
    return;
  }
  // Remove leading/trailing spaces before submitting
  this.quoteReviewnotes = this.quoteReviewnotes.trim();

    document.getElementById("closereviewbutton").click();

    this.isloading = true;
    this.PricingQuotesMaster.PriceQuoteReviewStatus(this.tokenKey, this.priceQuoteId, this.quoteReviewStatusId, this.quoteReviewnotes, this.userID).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          this.isSubmit = false;
          if (data['message'] != "")
            this.showMessage(data['message'], 'Warning', 'warning')
          else {
            this.showMessage("Quote Review Status update successfully", 'Success', 'success')
          }

          this.GetPriceQuoteReviewStatus(this.priceQuoteId);
        }
      },
      error => { this.stateCode = error }
    );
  }
}

